import './Register.css';
import {useState} from "react";

export const registerParticipation = async (registration_data, setRegistration) => {
  try {
    const response = await fetch(
        'https://nt6dwl1xpc.execute-api.us-west-1.amazonaws.com/produccion/register-participation/cicese',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(registration_data), // Corregido: enviar como JSON string
        },
    );
    const data = await response.json();
    console.log(data);
    setRegistration({});
  } catch (error) {
    console.error('Error:', error);
  }
};

export const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [institution, setInstitution] = useState("");
  const [occupation, setOccupation] = useState("");
  const [registration, setRegistration] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <>
      <div className="snn-page-section">
        <p>Si vas a asisir al evento y quieres recibir toda la información del evento registra tu asistencia</p>
        {registration ?
            <div>Registrado correctamente</div> :
            (
                <form className="register-form">
                  <label>
                    Nombre:
                    <input type="text" value={name} onChange={e => setName(e.target.value)} required />
                  </label>
                  <br />
                  <label>
                    Correo:
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
                  </label>
                  <br />
                  <label>
                    Institución:
                    <input type="text" value={institution} onChange={e => setInstitution(e.target.value)} required />
                  </label>
                  <br />
                  <label>
                    Ocupación:
                    <input type="text" value={occupation} onChange={e => setOccupation(e.target.value)} required />
                  </label>
                  <br />
                  <button
                    onClick={async (e) => {
                      e.preventDefault();
                      setIsSubmitting(true);
                      await registerParticipation({name: name, email: email, institution: institution, occupation: occupation}, setRegistration);
                      setIsSubmitting(false);
                    }}
                    type="submit"
                    disabled={isSubmitting}
                  >Registrar</button>
                </form>
            )
        }

      </div>
    </>
  );
};
